export default "__VITE_ASSET__BZsD_Eh5__"